import React, { useState, useEffect}  from 'react';
import { DataContext } from '../App';
import { Bar } from "react-chartjs-2";
import {
    LineElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
    PointElement
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
    PointElement
);

ChartJS.register(annotationPlugin);
//ChartJS.register(ChartDataLabels);

const {getPadding, average, min, max} = require('../utils.js');
const {lerpColor, linSpace, clamp} = require('../colorutils.js');

function Persistence(){
    const data = React.useContext(DataContext);

    const persistence = data.historical_persistence;
    const nHist = persistence.length;
    const colors = {
        red: '#a10303',
        yellow: '#f5d742',
        amber: '#FF9800',
        green: '#34d3a1',
        blue: '#345ed3',
        black: '#000000'
    };

    // colors for the persistence diagram
    var yellow2red = linSpace(0.0, nHist, 1.0/(nHist-1))
    yellow2red = yellow2red.map(x => lerpColor(colors.yellow, colors.red, x))

    // variable font size depending on the screen size
    const [windowWidth, setWindowWidth] = useState(0);
    const updateDimensions = () => {
        const windowWidth = window.innerWidth
        setWindowWidth(windowWidth)
    }
    useEffect(() => { 
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize",updateDimensions);
    }, []);

    const fs = windowWidth > 1600 ? 12 : 8;

    const chartdata = {
        labels: ['1 day', '2 days', '3 days', '4 days', '5 days', '6 days', '7 days',
                 '8 day', '9 days', '10 days', '11 days', '12 days', '13 days', '14 days'
                ],
        
        datasets: [{
            label: 'Percentage of traps with N detections in the last 14 days',
            data: persistence,
            backgroundColor: yellow2red,
            borderRadius: 10,
            borderSkipped: false,
            datalabels: {
                display: function(context) {
 
                    return context.dataset.data[context.dataIndex] > 0 // display labels > 0
                    // return context.dataIndex % 2; // display labels with an odd index
                },
                color: colors.black,
                formatter: function(value, context) {
                    return value.toFixed(0) + '%';
                },
                anchor: 'end',
                align: 'end',
                font: {
                    size: fs
                }
            }//,

            //categoryPercentage: 0.8,
            //barPercentage: 0.8
        }]
    };
    
    const options = {
        scales: {
            y: {
                beginAtZero: true,
                max: max(persistence) + 10,
                min: -1,
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: false,
                }
            },
            x: {
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: true,
                    maxRotation: 45,
                    minRotation: 45

                }
            }
        },
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false,
            }
        }
    };

    return(
        <div className="card-body">
            <div style={{height:"180px"}}>
                <Bar
                    plugins={[ChartDataLabels]}
                    data={chartdata}
                    options={options}
                />
            </div>
        </div>

    );

}

export default Persistence;